import React, { useState } from "react";
import {
  Title,
  GoBack,
  MyMessage,
  InputField,
  MyActionButton,
} from "../../component/Component";
import { codeOk } from "../../../../middlewares/index";
import { FOLDERS } from "../../../doseeData/utils/Utils";
import { usePlugImageContext } from "../../../../context/plugImage/PlugImageContext";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";
import { FiImage, FiUpload, FiInfo } from "react-icons/fi";

const Add = () => {
  const { createOnePlugImage } = usePlugImageContext();
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [type, setType] = useState(null);
  const plugImageRoutes = "/plug/image";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setType(null);
  };

  const responses = (isError, message) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const addOnePlugImageHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Plug Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = { type, photo_url: thumbnail, image_cdn_id: thumbnailId };
    const { status, message } = await createOnePlugImage(data);
    if (status === codeOk) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50">
      <div className="mx-auto max-w-5xl p-4 lg:p-6">
        <div className="flex items-center justify-between">
          <GoBack props={{ route: plugImageRoutes }} />
          <span className="hidden sm:inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
            New entry
          </span>
        </div>

        <header className="mt-3 flex items-center gap-3">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
            <FiImage className="h-5 w-5" />
          </span>
          <div>
            <h1 className="text-lg font-semibold tracking-tight text-gray-900">
              Add Plug Image
            </h1>
            <p className="text-sm text-gray-600">Upload an image and set its type.</p>
          </div>
        </header>

        <div className="mt-4">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        </div>

        <form onSubmit={addOnePlugImageHandler} className="mt-2">
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="px-5 py-5">
              <div className="mb-3 flex items-center gap-2 text-xs font-semibold text-gray-700">
                <FiUpload className="h-4 w-4" />
                <span>Upload</span>
                <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold text-gray-600">
                  JPG · PNG
                </span>
              </div>

              <div className="rounded-xl border border-dashed border-gray-300 bg-gray-50 p-3 sm:p-4">
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={FOLDERS.PLUGS}
                />
                <p className="mt-2 flex items-center gap-2 text-[11px] text-gray-500">
                  <FiInfo className="h-3.5 w-3.5" />
                  Recommended 1200×675px. Keep files under 2MB for best performance.
                </p>
              </div>
            </div>

            <div className="border-t border-gray-100" />

            <div className="px-5 py-5">
              <div className="mb-3">
                <Title props={{ title: "Plug Image Details" }} />
              </div>

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <InputField
                  props={{
                    id: "type",
                    title: "Type",
                    type: "text",
                    value: type ? type : "",
                    onChange: (e) => {
                      setType(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <div className="hidden sm:block" />
              </div>
            </div>

            <div className="border-t border-gray-100" />

            <div className="px-5 py-4">
              <div className="flex items-center justify-end">
                <MyActionButton
                  loading={loading}
                  title="Add Plug Image"
                  onClick={() => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage(null);
                  }}
                />
              </div>
            </div>
          </div>
        </form>

        <p className="mt-3 flex items-center gap-2 text-xs text-gray-500">
          <FiInfo className="h-3.5 w-3.5" />
          Make sure the image is clear and appropriate for the selected type.
        </p>
      </div>
    </div>
  );
};

export default Add;
